//@ts-ignore
import {
  createMemo,
  createSignal,
  Show,
  createEffect,
  onMount,
  onCleanup,
} from "solid-js";
import {
  View,
  Text,
  hexColor,
} from "@lightningtv/solid";
import { Column, Row } from "@lightningtv/solid-ui";
import { useLocation, useNavigate, useParams } from "@solidjs/router";
import styles from "../../styles";
import channelsProvider from "../../api/providers/channels";
import { createInfiniteScroll } from "../../components/pagination";
import channelsCategories from "../../api/providers/channelsCategories";
import SelectedChannelEpg from "./channelMenuComponents/SelectedChannelEpg";
import { LazyUp } from "@lightningtv/solid/primitives";
import videoPlayerPreview from "../../video";
import {
  focusStore,
  lastStream,
  playListPassword,
  playListUrl,
  playListUsername,
  setFocusStore,
  setLastStream,
  setPreviewToNotShow,
} from "../../../state";
import LoadingIndicator from "../loading/loading";
import { Buffer } from "buffer";
import { useDebounce } from "../../components/useDebounce";
import { fontFamily, isRTL, t } from "../../translations/configuration";
import ConfirmPin from "../../components/ConfirmPin";
import Header from "../../components/Header";
import { IconButton } from "../../components/playlistComponents/TopRightHeaders";
import { getImageUrlAbsolute } from "../../api";

const ChannelMenu = props => {
  let myButton: any;
  let search: any;
  let viewRef: any, headerRef: any;
  let timeoutId: any = false;
  let preview: any;
  let channelItem: any;
  let addFavButtonRef: any;
  let debouncedHandleCategoryPress: any;
  let timeoutOfEpg: any;
  let searchIndexTimeout: any;
  let settinsRef: any;
  let cancelExit;
  let okExit;
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();

  const [lastCategoryID, setLastCategoryID] = createSignal(null);
  const [number, setNumber] = createSignal("1");
  const [isFavChannel, setIsFavChannel] = createSignal(false);
  const [channelLogo, setChannelLogo] = createSignal("");
  const [listOfFav, setListOfFav] = createSignal<any>({});
  const [channelData, setChannelData] = createSignal<any>({});
  const [isScreenFirstOpen, setIsScreenFirstOpen] = createSignal(true);
  const [isPreviewFocused, setIsPreviewFocused] = createSignal(false);
  const [isChannelsLoading, setIsChannelsLoading] = createSignal(false);
  const [enter, setEnter] = createSignal<any>(null);
  const [lastElement, setLastElement] = createSignal<any>(null);
  const [something, setSomething] = createSignal<any>(true);
  const [shouldStart, setShouldStart] = createSignal<any>(true);
  const [isDataReady, setIsDataReady] = createSignal(false);
  const [canExecuteEscape, setCanExecuteEscape] = createSignal(false);
  const [isReadyToRight, setIsReadyToRight] = createSignal(false);
  const [isDialogOpenExit, setIsDialogOpenExit] = createSignal<boolean>(false);
  const [lastFocusedLazyUp, setLastFocusedLazyUp] = createSignal('first');
  const [focusedCategory, setFocusedCategory] = createSignal(null);

  const [currentPreviewChannel, setCurrentPreviewChannel] = createSignal(null);
  const [focusedChannelId, setFocusedChannelId] = createSignal(null);
  const [isPreviewPlaying, setIsPreviewPlaying] = createSignal(false);
  const [enterPressCount, setEnterPressCount] = createSignal(0);
  const [isStreamChanging, setIsStreamChanging] = createSignal(false);

  const [toggledCategoryIDs, setToggledCategoryIDs] = createSignal(
    JSON.parse(localStorage.getItem("categoryIDs") || "[]")
  );
  const [pinAction, setPinAction] = createSignal<"toggleLock" | "enterChannel" | null>(null);
  const [categoryToToggle, setCategoryToToggle] = createSignal<string | null>(null);
  const [showPinInput, setShowPinInput] = createSignal(false);
  const [pendingCategoryId, setPendingCategoryId] = createSignal(null);
  const [streamID, setStreamID] = createSignal(null);
  const [isEnterProcessing, setIsEnterProcessing] = createSignal(false);

  let enterCallCount = 0;
  let enterCallTimer = null;

  const providerCategory = createMemo(() => {
    return createInfiniteScroll(channelsCategories(params.filter || "all"));
  });

  const provider = createMemo(() => {
    return createInfiniteScroll(channelsProvider(params.filter || "all", number()));
  });

  const safeFocus = (ref: any) => {
    if (ref && typeof ref.setFocus === 'function') {
      ref.setFocus();
    }
  };

  const handleNumberChange = (newNumber: any) => {
    if (number() === newNumber) return;
    setNumber(newNumber);
  };

  const handleCategoryPress = (categoryID: string) => {
    handleNumberChange(categoryID);
    setIsChannelsLoading(false);
    setTimeout(() => { setIsReadyToRight(false); }, 200);
  };

  function customEnter(stream_id: any) {
    setPreviewToNotShow(false);
    videoPlayerPreview.setFullScreen();
    navigate(`/livetv?num=${stream_id}`);
    setFocusStore("enterChannels", enter());
  }

  const handleEnterHold = (categoryID) => {
    if (localStorage.getItem('userPin') === null) {
      setTimeout(() => { cancelExit.setFocus(); }, 600);
      setIsDialogOpenExit(true);
    } else {
      const categories = providerCategory().pages();
      const category = categories.find(cat => cat.categoryID === categoryID);
      if (!category) return;
      const isCurrentlyLocked = toggledCategoryIDs().includes(categoryID);
      if (isCurrentlyLocked && isAdultCategory(categoryID, category.category_name)) return;
      setPendingCategoryId(categoryID);
      setPinAction("toggleLock");
      setShowPinInput(true);
      videoPlayerPreview.destroy();
    }
  };

  const addToFavorites = (channel) => {
    const currentPlaylistUrl = playListUrl();
    const existingChannels = localStorage.getItem("@favoriteChannels");
    let existingChannelsArray = existingChannels ? JSON.parse(existingChannels) : [];
    const isChannelExist = existingChannelsArray.some((existingChannel) => {
      const channelId = existingChannel.data?.stream_id || existingChannel.stream_id;
      const inputChannelId = channel.data?.stream_id || channel.stream_id;
      return channelId === inputChannelId && existingChannel.playlistUrl === currentPlaylistUrl;
    });
    if (!isChannelExist) {
      existingChannelsArray.push({ ...channel, playlistUrl: currentPlaylistUrl });
    } else {
      existingChannelsArray = existingChannelsArray.filter((existingChannel) => {
        const channelId = existingChannel.data?.stream_id || existingChannel.stream_id;
        const inputChannelId = channel.data?.stream_id || channel.stream_id;
        return !(channelId === inputChannelId && existingChannel.playlistUrl === currentPlaylistUrl);
      });
    }
    localStorage.setItem("@favoriteChannels", JSON.stringify(existingChannelsArray));
    const currentPlaylistFavorites = existingChannelsArray.filter(f => f.playlistUrl === currentPlaylistUrl);
    setListOfFav(currentPlaylistFavorites);
    const inputChannelId = channel.data?.stream_id || channel.stream_id;
    setIsFavChannel(currentPlaylistFavorites.some(f => (f.data?.stream_id || f.stream_id) === inputChannelId));
  };

  // ── FIX: removed the redundant videoPlayerPreview.setPreviewScreen() call
  // that was here after playVideo(). setPreviewScreen is already called inside
  // prepareAsync in video.ts, so calling it again here caused a race condition
  // and broke the display rect alignment.
  const showPreviewVideo = async (streamUrl: string, channelId: string) => {
    if (!location.pathname.startsWith("/channel-menu")) return;
    setLastStream(streamUrl);
    setCurrentPreviewChannel(channelId);
    setIsPreviewPlaying(true);
    setIsStreamChanging(true);
    videoPlayerPreview.destroy();
    try {
      await videoPlayerPreview.playVideo(streamUrl, "preview", isRTL());
      // ← setPreviewScreen is called inside prepareAsync in video.ts — do NOT call it again here
      setShouldStart(true);
      setIsStreamChanging(false);
    } catch (error) {
      console.error("Error playing video:", error);
      setIsPreviewPlaying(false);
      setIsStreamChanging(false);
    }
  };

  const startDirect = async (streamUrl: string) => {
    if (!location.pathname.startsWith("/channel-menu") || lastStream() === streamUrl) return;
    setLastStream(streamUrl);
    try {
      navigate(`/livetv?num=${streamUrl}&isTrue=true`);
    } catch (error) {
      console.error("Error playing video:", error);
    }
  };

  let timeoutPreview: any;

  const proceedWithCategory = (categoryId, stream_id) => {
    setEnter(categoryId);
    if (!shouldStart()) setShouldStart(false);
    if (lastStream() !== getStreamUrl(stream_id) && videoPlayerPreview) {
      videoPlayerPreview.destroy();
      setPreviewToNotShow(false);
      navigate(`/livetv?num=${stream_id}&isTrue=true`);
      clearTimeout(timeoutPreview);
      setFocusStore("enterChannels", enter());
    } else {
      customEnter(stream_id);
    }
  };

  const getStreamUrl = (stream_id: string) => {
    const baseUrl = `${playListUrl()}/live/${playListUsername()}/${playListPassword()}/${stream_id}.ts`;
    return localStorage.getItem("vpn") === "on" && localStorage.getItem("proxy_url")
      ? `${localStorage.getItem("proxy_url")}${Buffer.from(baseUrl, "utf-8").toString("base64")}`
      : baseUrl;
  };

  function ThumbnailChannel(props: any) {
    const isFavorited = () => {
      const currentPlaylistUrl = playListUrl();
      return listOfFav().some((favChannel) => {
        const favChannelId = favChannel.stream_id || favChannel.data?.stream_id;
        return favChannelId === props.stream_id && favChannel.playlistUrl === currentPlaylistUrl;
      });
    };

    const handleEnter = () => {
      const savedCategoryIDs = JSON.parse(localStorage.getItem("categoryIDs") || "[]");
      const currentEnterCount = enterPressCount();
      setFocusStore("colonIndexChannels", props.index);

      if (savedCategoryIDs.includes(props.category_id)) {
        // Protected category - handle as before
        setEnter(props.category_id);

        if (!shouldStart()) {
          setShouldStart(false);
        }

        if (lastStream() !== getStreamUrl(props.stream_id) && videoPlayerPreview) {
          videoPlayerPreview.destroy();
          setPreviewToNotShow(false);
          navigate(`/livetv?num=${props.stream_id}&isTrue=true&isLocked=true`);
          clearTimeout(timeoutPreview);
          setFocusStore("enterChannels", enter());
        } else {
          customEnter(props.stream_id);
        }
      } else {
        // NOT PROTECTED - FIXED LOGIC:
        // If preview is already playing for this channel OR this is any enter press, go to live TV
        if (isPreviewPlaying() && currentPreviewChannel() === props.stream_id) {
          console.log('Preview already playing - going directly to live TV');
          const channelToPlay = currentPreviewChannel() || props.stream_id;
          proceedWithCategory(props.category_id, channelToPlay);

          // Reset states
          setEnterPressCount(0);
          setIsPreviewPlaying(false);
          setCurrentPreviewChannel(null);
          setIsStreamChanging(false);
        } else if (currentEnterCount === 0) {
          // No preview playing and first enter - start preview
          console.log('First enter - starting preview for channel:', props.stream_id);
          setEnterPressCount(1);
          setIsStreamChanging(true);

          const streamUrl = getStreamUrl(props.stream_id);
          showPreviewVideo(streamUrl, props.stream_id);
        } else {
          // Fallback - go to live TV for any other case
          console.log('Fallback - going to live TV');
          const channelToPlay = currentPreviewChannel() || props.stream_id;
          proceedWithCategory(props.category_id, channelToPlay);

          // Reset states
          setEnterPressCount(0);
          setIsPreviewPlaying(false);
          setCurrentPreviewChannel(null);
          setIsStreamChanging(false);
        }
      }
    };

    const handleFocus = () => {
      setChannelLogo(props.stream_icon);
      if (focusedChannelId() !== props.stream_id) {
        setFocusedChannelId(props.stream_id);
        setEnterPressCount(0);
      }
      timeoutOfEpg = setTimeout(() => {
        setChannelData(props);
        setIsDataReady(true);
      }, 700);
      setFocusStore("enterChannels", null);
      clearTimeout(timeoutPreview);
      if (!isPreviewPlaying() && enterPressCount() === 0) {
        timeoutPreview = setTimeout(() => {
          const savedCategoryIDs = JSON.parse(localStorage.getItem("categoryIDs") || "[]");
          if (!savedCategoryIDs.includes(props.category_id)) {
            setShouldStart(false);
            setIsStreamChanging(true);
            const streamUrl = getStreamUrl(props.stream_id);
            showPreviewVideo(streamUrl, props.stream_id);
          }
        }, 1550);
      }
    };

    return (
      <View
        width={500} height={120}
        borderRadius={14}
        style={{
          borderRadius: 12,
          color: hexColor("#15171b"),
          border: { width: 0, color: hexColor("#2563eb") },
          focus: { border: { width: 2, color: hexColor("#2563eb") } },
          transition: { color: { duration: 200 } },
        }}
        ref={channelItem}
        onEnter={() => handleEnter()}
        onFocus={() => handleFocus()}
      >
        {/* Active indicator bar */}
        <View
          x={isRTL() ? 496 : 0} y={10}
          width={4} height={75}
          borderRadius={4}
          style={{
            color: hexColor("#00000000"),
            focus: { color: hexColor("#2563eb") },
          }}
        />

        {/* Channel logo box */}
        <View
          x={isRTL() ? 400 : 20} y={20}
          width={80} height={80}
          borderRadius={10}
          color={hexColor("#252830")}
        >
          <View
            x={5} y={5}
            width={70} height={70}
            src={
              props.stream_icon
                ? getImageUrlAbsolute(props.stream_icon)
                : "./assets/television.png"
            }
            borderRadius={8}
          />
        </View>

        {/* Channel name + number */}
        <View x={isRTL() ? 70 : 120} y={40}>
          <Text style={{
            fontSize: 24,
            color: hexColor("#f0f6fc"),
            fontWeight: isRTL() ? "normal" : "bold",
            fontFamily: fontFamily(),
          }}>
            {props?.name?.length > 20 ? `${props.name.substring(0, 20)}...` : props.name}
          </Text>
          <Text x={0} y={32} style={{
            fontSize: 18,
            color: hexColor("#6b7280"),
            fontFamily: fontFamily(),
          }}>
            Ch. {props.num}
          </Text>
        </View>

        {/* Play button — right side */}
        <View
          x={isRTL() ? 20 : 440} y={20}
          width={40} height={40}
          borderRadius={20}
          style={{
            color: hexColor("#1e3a5f"),
            focus: { color: hexColor("#2563eb") },
          }}
        >
          <View x={8} y={6} width={26} height={30} src="https://i.ibb.co/WNPhwwTN/Arrow-Forward.png" />
        </View>

        {/* Favorite heart — bottom right */}
        <View x={isRTL() ? 32 : 440} y={70} width={28} height={28}>
          <View
            width={30} height={30}
            src={
              isFavorited()
                ? "https://i.ibb.co/pRyqmgX/icons8-love-100-2.png"
                : "https://i.ibb.co/kHcHCDb/icons8-love-100.png"
            }
          />
        </View>

        {/* Live preview dot */}
        <Show when={currentPreviewChannel() === props.stream_id}>
          <View
            x={isRTL() ? 350 : 400} y={57}
            width={13} height={13}
            color={hexColor("#22c55e")}
            borderRadius={6}
          />
        </Show>
      </View>
    );
  }

  onMount(() => {
    debouncedHandleCategoryPress = useDebounce((categoryID: any) => {
      handleCategoryPress(categoryID);
      setTimeout(() => {
        setIsChannelsLoading(false);
        setTimeout(() => { setIsReadyToRight(false); }, 200);
      }, 50);
    }, 1000);
  });

  createEffect(() => {
    const index = focusStore.focusedIndexChannels;
    let timeout: any;
    if (index !== null) {
      timeout = setTimeout(() => { timeoutId = true; }, 1200);
    } else if (index === 0) {
      timeoutId = true;
    }
    onCleanup(() => { clearTimeout(timeout); });
  }, []);

  createEffect(() => {
    if (isScreenFirstOpen()) {
      handleCategoryPress("99999");
      setIsScreenFirstOpen(false);
    }
    localStorage.setItem("@emptyCategory", providerCategory().pages().length > 0 ? "false" : "true");
  }, [isScreenFirstOpen()]);

  createEffect(() => {
    const currentPlaylistUrl = playListUrl();
    const existingChannels = localStorage.getItem("@favoriteChannels");
    let existingChannelsArray = existingChannels ? JSON.parse(existingChannels) : [];
    const currentPlaylistFavorites = existingChannelsArray.filter(f => f.playlistUrl === currentPlaylistUrl);
    setListOfFav(currentPlaylistFavorites);
  }, [listOfFav()]);

  createEffect(() => {
    const enterID: any = focusStore.enterChannels;
    if (enterID !== null) {
      handleCategoryPress(enterID);
      setLastCategoryID(enterID);
    } else {
      setSomething(false);
    }
  });

  createEffect(() => {
    setCanExecuteEscape(false);
    const timer = setTimeout(() => { setCanExecuteEscape(true); }, 3000);
    onCleanup(() => clearTimeout(timer));
  });

  onMount(() => {
    const index = focusStore.colonIndexChannels;
    if (index === null) return;
    searchIndexTimeout = setTimeout(() => {
      viewRef?.setFocus();
      setSomething(false);
    }, 1200);
  });

  onCleanup(() => { clearTimeout(searchIndexTimeout); });

  const handlePinSubmit = (enteredPin: string) => {
    const savedPin = localStorage.getItem("userPin");
    if (enteredPin !== savedPin) { alert("Incorrect PIN. Please try again."); return; }
    const action = pinAction();
    const categoryId = pendingCategoryId();
    if (!categoryId) return;
    if (action === "enterChannel") {
      proceedWithCategory(categoryId, streamID());
    } else if (action === "toggleLock") {
      const categories = providerCategory().pages();
      const category = categories.find(cat => cat.categoryID === categoryId);
      if (!category) { setPendingCategoryId(null); setPinAction(null); setShowPinInput(false); return; }
      const savedIDs = [...toggledCategoryIDs()];
      const index = savedIDs.indexOf(categoryId);
      if (index !== -1 && isAdultCategory(categoryId, category.category_name)) {
        setPendingCategoryId(null); setPinAction(null); setShowPinInput(false); return;
      }
      if (index === -1) savedIDs.push(categoryId);
      else savedIDs.splice(index, 1);
      localStorage.setItem("categoryIDs", JSON.stringify(savedIDs));
      setToggledCategoryIDs(savedIDs);
    }
    setPendingCategoryId(null); setPinAction(null); setShowPinInput(false);
  };

  let holdTimer = null;
  let enterHeld = false;

  const handleKeyDown = (e) => {
    const lastFocused = focusedCategory();
    if (lastFocused === null) return;
    if ((e.key === 'Enter' || e.keyCode === 13) && !holdTimer) {
      holdTimer = setTimeout(() => { enterHeld = true; handleEnterHold(lastFocused); }, 600);
    }
  };

  const handleKeyUp = (e) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
      enterHeld = false;
    }
  };

  onMount(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
  });

  onCleanup(() => {
    window.removeEventListener('keydown', handleKeyDown);
    window.removeEventListener('keyup', handleKeyUp);
  });

  createEffect(() => {
    const categories = providerCategory().pages();
    if (!categories || categories.length === 0) return;
    const savedPin = localStorage.getItem('userPin');
    if (!savedPin) { localStorage.removeItem("categoryIDs"); return; }
    const adultCategoryIDs = categories
      .filter(cat => ["xxx", "porn", "adult"].some(k => cat.category_name.toLowerCase().includes(k)))
      .map(cat => cat.categoryID);
    const existingIDs = JSON.parse(localStorage.getItem("categoryIDs") || "[]");
    const mergedIDs = [...new Set([...existingIDs, ...adultCategoryIDs])];
    localStorage.setItem("categoryIDs", JSON.stringify(mergedIDs));
  });

  const savedPin = localStorage.getItem('userPin');

  const isAdultCategory = (categoryID: string, categoryName: string) => {
    const hasAdultKeyword = ["xxx", "porn", "adult"].some(k => categoryName.toLowerCase().includes(k));
    const categories = providerCategory().pages();
    const adultCategoryIDs = categories
      .filter(cat => ["xxx", "porn", "adult"].some(k => cat.category_name.toLowerCase().includes(k)))
      .map(cat => cat.categoryID);
    return hasAdultKeyword || adultCategoryIDs.includes(categoryID);
  };

  return (
    <Show when={showPinInput()} fallback={
      <View
        color={props.isFromLiveTv ? hexColor("#80808080") : hexColor("#0d0f14")}
        onEscape={() => {
          if (canExecuteEscape()) {
            navigate("/home");
            videoPlayerPreview.destroy();
            setFocusStore("focusedIndexChannels", null);
            setFocusStore("thumbnailIndexChannels", null);
            setFocusStore("enterChannels", null);
            setFocusStore("colonIndexChannels", null);
            setPreviewToNotShow(false);
            setIsPreviewPlaying(false);
            setCurrentPreviewChannel(null);
            setFocusedChannelId(null);
            setEnterPressCount(0);
            setIsStreamChanging(false);
            clearTimeout(searchIndexTimeout);
            onCleanup(() => { if (searchIndexTimeout) { clearTimeout(searchIndexTimeout); searchIndexTimeout = null; } });
          }
        }}
      >

        {/* ── Exit dialog ── */}
        <Show when={isDialogOpenExit()}>
          <View x={560} y={340} width={800} height={300} color={hexColor("#12151c")} borderRadius={20}>
            <View x={0} y={0} width={4} height={300} borderRadius={2} color={hexColor("#2563eb")} />
            <Text x={50} y={36} style={{ fontFamily: fontFamily(), fontSize: 24, color: hexColor("#f0f6fc"), fontWeight: isRTL() ? "normal" : "bold" }}>
              {t("pinNotSet")}
            </Text>
            <Text x={50} y={90} style={{ fontFamily: fontFamily(), fontSize: 22, color: hexColor("#9ca3af") }}>
              {t("setPinNow")}
            </Text>

            {/* Cancel */}
            <View
              ref={el => { cancelExit = el; }}
              x={440} y={220}
              width={150} height={50}
              borderRadius={10}
              style={{
                color: hexColor("#1a1d24"),
                focus: { color: hexColor("#1e3a5f") },
                transition: { color: { duration: 150 } },
              }}
              onEnter={() => { myButton.setFocus(); setIsDialogOpenExit(false); }}
              onRight={() => okExit.setFocus()}
            >
              <Text x={34} y={14} style={{ fontFamily: fontFamily(), fontSize: 20, color: hexColor("#d1d5db") }}>
                {t("cancelBig")}
              </Text>
            </View>

            {/* OK */}
            <View
              ref={el => { okExit = el; }}
              x={610} y={220}
              width={150} height={50}
              borderRadius={10}
              style={{
                color: hexColor("#2563eb"),
                focus: { color: hexColor("#3b82f6") },
                transition: { color: { duration: 150 } },
              }}
              onLeft={() => cancelExit.setFocus()}
              onEnter={() => { navigate("/userinfo?fromPIN=true"); }}
            >
              <Text x={58} y={14} style={{ fontFamily: fontFamily(), fontSize: 20, color: hexColor("#ffffff"), fontWeight: isRTL() ? "normal" : "bold" }}>
                {t("ok")}
              </Text>
            </View>
          </View>
        </Show>

        <Header screen={t("")} ref={(el) => headerRef = el}
          onRight={() => isRTL() ? null : search?.setFocus()}
          onLeft={() => isRTL() ? settinsRef?.setFocus() : null}
          onDown={() => lastFocusedLazyUp() === 'second' ? viewRef.setFocus() : myButton.setFocus()}
        />

        {/* ── Top-right: Search + Settings ── */}
        <View x={isRTL() ? 50 : 1700} y={50}>
          <IconButton
            onRef={(el) => { search = el; }}
            x={0} y={0}
            src="https://i.ibb.co/nNhBcw8M/search.png"
            onLeft={() => isRTL() ? null : headerRef?.setFocus()}
            onDown={() => lastFocusedLazyUp() === 'second' ? viewRef.setFocus() : myButton.setFocus()}
            onEnter={() => {
              navigate("/searchlive");
              setFocusStore("focusedIndexChannels", null);
              setFocusStore("thumbnailIndexChannels", null);
              setFocusStore("enterChannels", null);
              setFocusStore("colonIndexChannels", null);
              videoPlayerPreview.destroy();
            }}
            onRight={() => settinsRef.setFocus()}
          />

          <IconButton
            onRef={(el) => { settinsRef = el; }}
            x={100} y={0}
            src="https://i.ibb.co/Jjp8bmn4/setting.png"
            onEnter={() => { navigate("/userInfo"); videoPlayerPreview.destroy(); }}
            onLeft={() => isRTL() ? safeFocus(search) : safeFocus(search)}
            onRight={() => isRTL() ? safeFocus(headerRef) : null}
            onDown={() => safeFocus(myButton)}
          />
        </View>

        {/* ── Stream change loading overlay ── */}
        <Show when={isStreamChanging()}>
          <View
            color={hexColor("#000000")}
            zIndex={1001}
            width={660} height={360}
            x={isRTL() ? 65 : 1170} y={180}
          >
            <View x={250} y={80}>
              <LoadingIndicator />
            </View>
          </View>
        </Show>

        <Show when={!shouldStart() && !isStreamChanging()}>
          <View color={hexColor("#000000")} zIndex={999} width={660} height={360} x={isRTL() ? 70 : 1170} y={180}>
            <View x={250} y={80}>
              <LoadingIndicator />
            </View>
          </View>
        </Show>

        <View y={120}>
          <Show
            when={providerCategory().pages() && providerCategory().pages().length > 0}
            fallback={
              <View x={750} y={500}>
                <Text fontSize={30} color={hexColor("#7d7e82")} style={{ fontFamily: fontFamily() }}>
                  {t("noChannels")}
                </Text>
              </View>
            }
          >
            <View y={50} clipping>

              {/* ── Category list ── */}
              <LazyUp
                ref={myButton}
                onSelectedChanged={setLastElement}
                onFocus={() => setLastFocusedLazyUp('first')}
                x={isRTL() ? 1350 : 60}
                y={10}
                gap={10}
                onRight={() => {
                  if (!isRTL()) {
                    if (!isReadyToRight()) viewRef.setFocus();
                  }
                }}
                onLeft={() => {
                  if (isRTL()) {
                    if (!isReadyToRight()) viewRef.setFocus();
                  }
                }}
                onBlur={() => setFocusedCategory(null)}
                component={Column}
                scroll="always"
                onUp={() => search.setFocus()}
                upCount={12}
                selected={focusStore.focusedIndexChannels === null ? 0 : focusStore.focusedIndexChannels}
                autofocus={true}
                each={[{ category_name: "Favorites", categoryID: "99999" }, ...providerCategory().pages()]}
              >
                {(item, index: any) => {
                  const currentCategoryID = item().categoryID;
                  const isToggled = () => toggledCategoryIDs().includes(currentCategoryID);

                  return (
                    <View
                      borderReadius={12}
                      style={{
                        width: 480,
                        height: 95,
                        borderRadius: 12,
                        color: hexColor("#15171b"),
                        border: { width: 0, color: hexColor("#2563eb") },
                        focus: { border: { width: 2, color: hexColor("#2563eb") } },
                        transition: { color: { duration: 200 } },
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onFocus={() => {
                        setFocusedCategory(item().categoryID);
                        if (focusStore.enterChannels !== null) return;
                        if (lastCategoryID() !== item().categoryID) {
                          setIsChannelsLoading(true);
                          setIsReadyToRight(true);
                        }
                        const currentCategoryID = item().categoryID;
                        if (something() !== true) {
                          debouncedHandleCategoryPress(currentCategoryID);
                          setLastCategoryID(currentCategoryID);
                        }
                        setFocusStore("focusedIndexChannels", index);
                      }}
                      onUp={() => {
                        if (timeoutId === false) return true;
                        else {
                          setFocusStore("thumbnailIndexChannels", null);
                          setFocusStore("colonIndexChannels", null);
                        }
                      }}
                      onDown={() => {
                        if (timeoutId === false) return true;
                        else {
                          setFocusStore("thumbnailIndexChannels", null);
                          setFocusStore("colonIndexChannels", null);
                        }
                      }}
                    >
                      {/* Active indicator bar */}
                      <View
                        x={isRTL() ? 496 : 0} y={10}
                        width={4} height={75}
                        borderRadius={4}
                        style={{
                          color: hexColor("#00000000"),
                          focus: { color: hexColor("#2563eb") },
                        }}
                      />

                      <Text x={24} y={34} width={432}
                        contain="width"
                        textAlign={isRTL() ? "right" : "left"}
                        style={{
                          fontSize: 26,
                          color: hexColor("#e2e8f0"),
                          fontFamily: fontFamily(),
                        }}>
                        {item().category_name.length > 22
                          ? `${item().category_name.substring(0, 22)}...`
                          : item().category_name}
                      </Text>

                      <Show when={savedPin}>
                        <View
                          src={
                            isToggled()
                              ? "https://i.ibb.co/jPvhs2HJ/lock.png"
                              : "https://i.ibb.co/N2Ym8McH/unlock.png"
                          }
                          width={24} height={24}
                          x={isRTL() ? 26 : 430} y={36}
                          style={
                            isToggled() && isAdultCategory(item().categoryID, item().category_name)
                              ? { opacity: 0.5 }
                              : {}
                          }
                        />
                      </Show>
                    </View>
                  );
                }}
              </LazyUp>

              {/* ── Preview panel (top-right) ── */}
              <View
                ref={preview}
                x={isRTL() ? 50 : 1150}
                y={0}
                height={380}
                width={700}
                borderRadius={16}
                clipping
                style={{
                  focus: { border: { width: 2, color: hexColor("#2563eb") } },
                  border: { width: 2, color: hexColor("#1e2a3a") },
                }}
                onDown={() => { addFavButtonRef.setFocus(); setIsPreviewFocused(false); }}
                onLeft={() => { viewRef.setFocus(); setIsPreviewFocused(false); }}
                onUp={() => search.setFocus()}
                // onRight={() => { addFavButtonRef?.setFocus(); setIsPreviewFocused(false); }}
                onEnter={() => {
                  const channelToPlay = currentPreviewChannel() || channelData().stream_id;
                  customEnter(channelToPlay);
                }}
                onFocus={() => setIsPreviewFocused(true)}
              >
                {/* "Tap to play" placeholder when no preview */}
                <Show when={!isPreviewPlaying()}>
                  <Text
                    x={260} y={170}
                    style={{
                      fontFamily: fontFamily(),
                      color: isPreviewFocused() ? hexColor("#f0f6fc") : hexColor("#6b7280"),
                      fontSize: 22,
                    }}
                  >
                    {t("tapToPlay")}
                  </Text>
                  <Show when={channelLogo()}>
                    <View x={310} y={180} src={channelLogo()} width={100} height={100} />
                  </Show>
                </Show>
              </View>

              {/* ── EPG / channel info panel ── */}
              <View
                x={isRTL() ? 40 : 1150}
                y={400}
                width={760}
                borderRadius={16}
                clipping
                plinko
              >
                <Show when={isDataReady()}>
                  <SelectedChannelEpg channel={channelData()}
                    onFavRef={(el) => { addFavButtonRef = el; }}
                    onFavUp={() => preview.setFocus()}
                    onFavLeft={() => isRTL() ? null : safeFocus(viewRef)}
                    onFavRight={() => isRTL() ? safeFocus(viewRef) : null}
                    onFavToggle={() => addToFavorites(channelData())}
                  />
                </Show>
              </View>
            </View>

            {/* ── Channel list ── */}
            <View
              x={isRTL() ? 650 : 420}
              y={80}
              onLeft={() => { isRTL() ? null : myButton.setFocus(); }}
              onRight={() => { isRTL() ? myButton.setFocus() : null; }}
              clipping
              style={styles.itemsContainerChannelMenu}
            >
              <Show
                when={provider().pages()}
                fallback={
                  <View x={500} y={100}>
                    <LoadingIndicator isCategoriesIndicator={false} />
                  </View>
                }
              >
                <Show
                  when={provider().pages().length > 0}
                  fallback={
                    <View x={300} y={250}>
                      <Text y={50} style={{ fontFamily: fontFamily(), color: hexColor("#7d7e82"), fontSize: 28 }}>
                        {t("categoryEmpty")}
                      </Text>
                    </View>
                  }
                >
                  <Show
                    when={isChannelsLoading()}
                    fallback={
                      <LazyUp
                        ref={viewRef}
                        onFocus={() => setLastFocusedLazyUp('second')}
                        style={styles.Column}
                        plinko
                        gap={10}
                        onBlur={() => setEnterPressCount(0)}
                        onUp={() => search.setFocus()}
                        onRight={() => { if (!isRTL()) safeFocus(addFavButtonRef); }}
                        onLeft={() => { if (isRTL()) safeFocus(addFavButtonRef); }} component={Column}
                        scroll="always"
                        upCount={10}
                        y={0}
                        each={provider().pages()}
                        selected={
                          focusStore.colonIndexChannels === null
                            ? 0
                            : (() => {
                              const index = focusStore.colonIndexChannels;
                              if (index !== null) { setTimeout(() => { }, 300); return index; }
                            })()
                        }
                      >
                        {(items, i: any) => <ThumbnailChannel {...items()} index={i} />}
                      </LazyUp>
                    }
                  >
                    <View x={330} y={200}>
                      <LoadingIndicator isCategoriesIndicator={true} />
                    </View>
                  </Show>
                </Show>
              </Show>
            </View>
          </Show>
        </View>
      </View>
    }>
      <View onEscape={() => setShowPinInput(false)}>
        <ConfirmPin onPinSet={handlePinSubmit} />
      </View>
    </Show>
  );
};

export default ChannelMenu;